export let RuleListStatus = /*#__PURE__*/function (RuleListStatus) {
  RuleListStatus["failed"] = "failed";
  RuleListStatus["passed"] = "passed";
  RuleListStatus["error"] = "error";
  return RuleListStatus;
}({});
export const SITE_LEVEL_PAGE_ID = 'site-level';
export const getAnalyzeRuleExecutionResults = results => {
  var _mostRecentDate;
  const ruleFailures = new Map();
  let mostRecentDate = null;
  for (const result of results) {
    var _result$metadata, _result$result;
    const pageId = ((_result$metadata = result.metadata) == null ? void 0 : _result$metadata.pageId) || SITE_LEVEL_PAGE_ID;
    const ruleId = result.ruleId;
    const status = (_result$result = result.result) == null ? void 0 : _result$result.status;
    const key = `${pageId}:${ruleId}`;
    const createdDate = new Date(result.dateCreated ?? '');
    if (!mostRecentDate || createdDate > mostRecentDate) {
      mostRecentDate = createdDate;
    }
    if (status === RuleListStatus.failed) {
      ruleFailures.set(key, true);
    }
  }
  return {
    totalFailedRules: ruleFailures.size,
    mostRecentDate: ((_mostRecentDate = mostRecentDate) == null ? void 0 : _mostRecentDate.toISOString()) || null
  };
};
//# sourceMappingURL=site-execution-result.js.map